import React from 'react';
import classnames from 'classnames';

import Is, { Props as IsProps, IsComponent } from '@/components/Is';

import style from './Tag.sass';

export interface TagsProps {
  className?: string;
}

export const Tags: React.FC<TagsProps> = ({ children, className }) => (
  <ul className={classnames(style.tags, className)}>{children}</ul>
);

export interface TagProps {
  className?: string;
}

export const Tag: React.FC<TagProps> = ({ children, className }) => (
  <li className={classnames(style.tag, className)}>{children}</li>
);

export type TagContentProps<P extends IsComponent> = IsProps<P> & {
  className?: string;
};

export class TagContent<P extends IsComponent> extends React.PureComponent<TagContentProps<P>> {
  static defaultProps: Pick<TagContentProps<any>, 'is'> = {
    is: 'div'
  };

  render() {
    return <Is {...this.props} className={classnames(style.content, this.props.className)} />;
  }
}
